import React from 'react';
import { useTranslation } from 'react-i18next';
import { Database, CheckCircle, AlertTriangle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';

const getStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case 'completed': return 'bg-green-950/30 text-green-400';
    case 'failed': return 'bg-red-950/30 text-red-400';
    case 'in_progress': return 'bg-primary/10 text-primary';
    default: return 'bg-muted text-muted-foreground';
  }
};

const BiometricSyncHistory = ({ syncHistory }) => {
  const { t, i18n } = useTranslation();
  return (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Database className="h-5 w-5" />
        {t('biometricComp.syncHistTitle')}
      </CardTitle>
    </CardHeader>
    <CardContent>
      {syncHistory.length > 0 ? (
        <div className="space-y-2">
          {syncHistory.slice(0, 5).map((log, index) => (
            <div key={index} className="flex items-center justify-between p-3 bg-muted/50 rounded-lg">
              <div className="flex items-center space-x-3">
                <Badge className={getStatusColor(log.status)}>
                  {log.status === 'completed' ? (
                    <CheckCircle className="h-3 w-3 mr-1" />
                  ) : (
                    <AlertTriangle className="h-3 w-3 mr-1" />
                  )}
                  {log.status}
                </Badge>
                <div>
                  <div className="font-medium">{log.terminal_serial} - {log.sync_type}</div>
                  <div className="text-sm text-muted-foreground">
                    {t('biometricComp.syncStats', { fetched: log.records_fetched, mapped: log.records_mapped, unmapped: log.records_unmapped })}
                  </div>
                </div>
              </div>
              <div className="text-right text-xs text-muted-foreground">
                {new Date(log.created_at).toLocaleString(i18n.language)}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center text-muted-foreground py-4">{t('biometricComp.noHistory')}</p>
      )}
    </CardContent>
  </Card>
  );
};

export default BiometricSyncHistory;
